const PrettyDivider = () => {
    return <div className="w-full flex gap-4 items-center">
    <div className="flex-1 bg-neutral-300 h-[.8px]"></div>
    <div className="h-[5px] w-[5px] bg-neutral-700 rounded-full"></div>
    <div className="flex-1 bg-neutral-300 h-[.8px]"></div>
  </div>
  }

  export default PrettyDivider;